export const LANDING_PAGE_URL = 'https://vizion.space';

export const ROUTE_MAP = {
  overview: {
    id: 'tong-quan',
    label: 'overview',
  },
  'floor-plan': {
    id: 'mat-bang-tang',
    label: 'floor_plan_layout',
  },
  masterplan: {
    id: 'so-do-tong-the',
    label: 'overview_layout',
  },
  interior: {
    id: 'can-ho',
    label: 'apartment',
  },
  neighborhood: {
    id: 'lien-ket-vung',
    label: 'surrounding_map',
  },
  amenities: {
    id: 'tien-ich',
    label: 'amenities_layout',
  },
  amenityLayout: {
    id: 'so-do-tien-ich',
    label: 'amenities_layout',
  },
  library: {
    id: 'thu-vien',
    label: 'library',
  },
};

export const SCENE_IDS = {
  main_view: '691c1bc39d4e2e854cda3edb',
  studio: '691c24029d4e2e854cda4b2c',
  '1pn': '691c21599d4e2e854cda4544',
  '2pn': '691c22439d4e2e854cda4844',
  '3pn': '691c269d9d4e2e854cda4f82',
};
